import { useGetTaskQuestionGroupByIdsQuery } from '@exam-management/graphql';
import {
  CircularProgress,
  Flex,
  Table,
  TableContainer,
  type TableContainerProps,
} from '@shared/components';

import { EmptyQuestionList, QuestionTypeLabel } from '../../components';
import { useQuestionCreationTaskDetails } from '../../providers';

import ItemSetQuestionListTableBody from './item-set-question-list-table-body';
import ItemSetQuestionListTableHeader from './item-set-question-list-table-header';

export default function ItemSetQuestionListTable(props: Readonly<TableContainerProps>) {
  const { ...restProps } = props;
  const { task } = useQuestionCreationTaskDetails();
  const questionGroupIds =
    task.metadata?.requirement?.itemSetCreation?.map((itemSet) => itemSet.questionGroupId) ?? [];

  const { data, loading: isLoading } = useGetTaskQuestionGroupByIdsQuery({
    variables: {
      questionGroupIds,
      taskId: task.id,
    },
  });

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        overflow: 'hidden',
      })}
    >
      <QuestionTypeLabel type='item-set' />
      <TableContainer
        {...restProps}
        sx={{
          overflow: 'hidden',
          borderColor: (theme) => theme.palette.grey[300],
          ...restProps.sx,
        }}
      >
        <Table
          stickyHeader
          sx={{
            border: 'none',
            borderCollapse: 'initial',
            mb: '-1px',
            tableLayout: 'fixed',
          }}
        >
          <ItemSetQuestionListTableHeader />
          {/*WORKAROUND: td with colSpan*/}
          {data?.qctGetTaskQuestionGroupByIds.length === 0 ? (
            <td colSpan={8}>
              <EmptyQuestionList title='ยังไม่มีคำถาม Item Set' />
            </td>
          ) : (
            <ItemSetQuestionListTableBody rows={data?.qctGetTaskQuestionGroupByIds ?? []} />
          )}
        </Table>
        {isLoading ? (
          <Flex
            sx={{
              height: '124px',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress />
          </Flex>
        ) : null}
      </TableContainer>
    </Flex>
  );
}
